import type { BaseMediaType } from '../../../constants';
import { mediaTypes } from '../../../constants';

type ExtendedMediaType = BaseMediaType | 'noMedia';

export function matchMediaType(
  derivedType: string | undefined
): ExtendedMediaType | undefined {
  if (!derivedType) {
    return undefined;
  }

  const type = derivedType.toLowerCase();

  if (type in mediaTypes) {
    return type as BaseMediaType;
  }

  switch (type) {
    case 'album':
    case 'carousel':
    case 'carousel_album':
    case 'multi_share':
    case 'document':
      return 'gallery';

    case 'animated_gif':
    case 'photo':
    case 'cover_photo':
      return 'image';

    case 'share':
    case 'quote':
      return 'link';

    case 'video_inline':
    case 'video_direct_response':
    case 'video_direct_response_autoplay':
    case 'video_autoplay':
      return 'video';

    case 'text':
    case 'chat':
    case 'poll':
      return 'noMedia';

    default:
      console.warn(`Media type ${derivedType} is unrecognized`);

      return undefined;
  }
}
